var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurBlueDog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0069b1",
    d: "m19.05 2.85-3.8 3.8L18.1 9.5l.95-.95.95.95 1.9-1.9-2.85-2.85v-1.9m-15.2 3.8-.95.95 2.85 2.85v2.85l-.95.95v5.7h1.9V17.1l1.9-2.85h6.65v5.7h1.9v-9.5L14.3 7.6l-.95.95h-7.6l-1.9-1.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurBlueDog);
export default __webpack_public_path__ + "static/media/OurBlueDog.f62ce8007e153c367c5f623b12009a8c.svg";
export { ForwardRef as ReactComponent };